export enum RaceStatus {
  Pending,
  Started,
  Finished,
  Cancelled,
}
export enum RacePrizeType {
  OpponentCar = "OpponentCar",
  GameCash = "GameCash",
}
export enum RaceResult {
  Pending,
  WinnerWithNoCrash,
  WinnerWithCrash,
  BothCrash,
}
